import { render, staticRenderFns } from "./ScorePositionEdit.vue?vue&type=template&id=8878baa6&scoped=true&"
import script from "./ScorePositionEdit.vue?vue&type=script&lang=ts&"
export * from "./ScorePositionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ScorePositionEdit.vue?vue&type=style&index=0&id=8878baa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8878baa6",
  null
  
)

export default component.exports